let initialState = {
	welcomePage: true,
	graphDetail: {
		first: null,
		second: null,
		filter: null,
		split: null,
		base: "mentions",
		brands: null,
		duration: null,
		TicketTAT: null,
		aiLogScale:null,
	},
	ticketTAT: null,
	ticketSimpleView: null,
};

const Welcome = (state = initialState, action) => {
	switch (action.type) {
    case "SET_WELCOMEPAGE":
      return {
        ...state,
        welcomePage: action.payload,
      };
    case "SET_FIRST_ATTR":
      return {
        ...state,

        graphDetail: action.graphDetail,
      };
    case "SET_SECOND_ATTR":
      return {
        ...state,

        graphDetail: action.graphDetail,
      };
    case "SET_FILTER":
      return {
        ...state,

        graphDetail: action.graphDetail,
      };
    case "SET_SPLIT":
      return {
        ...state,

        graphDetail: action.graphDetail,
      };

    case "SET_BASE":
      return {
        ...state,

        graphDetail: action.graphDetail,
      };

    case "SET_GRAPH_BRANDS":
      return {
        ...state,

        graphDetail: action.graphDetail,
      };
    case "SET_GRAPH_DURATION":
      return {
        ...state,

        graphDetail: action.graphDetail,
      };
    case "SET_CLEAR_GRAPH_DETAILS":
      return {
        ...state,

        graphDetail: action.graphDetail,
      };
    case "SET_AI_LOG_SCALE":
      return {
        ...state,
        graphDetail: action.graphDetail,
      };
    case "SET_TICKET_TAT":
      return {
        ...state,

        ticketTAT: action.payload,
      };
    case "SET_TICKET_SIMPLE_VIEW":
      return {
        ...state,

        ticketSimpleView: action.payload,
      };

    default:
      return state;
  }
};

export default Welcome;
